'use client';
import LoaderPage from '../../components/LoaderPage';

const LoadingPage = () => {
	return <LoaderPage />;
};

export default LoadingPage;
